import React from 'react';
import { useUiSurfaceVisible } from '../hooks/useUiSurfaceVisible';

/**
 * Affiche les enfants seulement si la surface est autorisée sur le viewport courant
 * (réglages : Paramètres → Fiche & affichage → Affichage web / mobile).
 */
export default function UiSurface({ id, children, fallback = null, className = '' }) {
  const visible = useUiSurfaceVisible(id);
  if (!visible) return fallback;
  if (className) {
    return <div className={className}>{children}</div>;
  }
  return children;
}
